var map = {
	"./10s-ago.svg": "a6f6",
	"./10s-forward.svg": "e039",
	"./ab-test.svg": "d92d",
	"./add-outline.svg": "f440",
	"./add.svg": "0c04",
	"./additional.svg": "083a",
	"./affiliates.svg": "2948",
	"./ai.svg": "31cd",
	"./airplay.svg": "2c00",
	"./alert-outline.svg": "47de",
	"./analytics.svg": "ec34",
	"./back.svg": "422e",
	"./brazil.svg": "46c8",
	"./breadcumb.svg": "1c3c",
	"./calendar.svg": "253e",
	"./cc-android.svg": "8a93",
	"./cc-ios.svg": "419c",
	"./check-outline.svg": "8df8",
	"./check-round.svg": "f4d7",
	"./check-sucess.svg": "0ecb",
	"./chev-down.svg": "df42",
	"./chev-left.svg": "c9f0",
	"./chev-right-dark.svg": "1799",
	"./chev-right-light.svg": "fddb",
	"./chev-right.svg": "cbb4",
	"./chev-up.svg": "8746",
	"./chromecast.svg": "6084",
	"./close.svg": "8c8d",
	"./code-api.svg": "849f",
	"./color.svg": "56c6",
	"./columns.svg": "17f7",
	"./config.svg": "2672",
	"./copy.svg": "9e3a",
	"./credit-card.svg": "b8a9",
	"./customPixel.svg": "a5a0",
	"./desktop.svg": "7168",
	"./desktop_dark.svg": "ab91",
	"./dislike.svg": "fabf",
	"./doc.svg": "f3f4",
	"./download.svg": "6493",
	"./draft.svg": "c873",
	"./drm-off.svg": "8a21",
	"./drm-on-gradient.svg": "5b7d",
	"./drm-on.svg": "8ac9",
	"./edit.svg": "a2f2",
	"./error-outline.svg": "56c5",
	"./error-solid.svg": "9a4a",
	"./extra-content.svg": "d8ce",
	"./eye-appearing.svg": "a095",
	"./eye-hidden.svg": "9ba7",
	"./facebook.svg": "85a8",
	"./filter.svg": "7089",
	"./finance.svg": "bf13",
	"./folder.svg": "ce5f",
	"./fonts/panda.svg": "4eb4",
	"./fullscreen.svg": "5417",
	"./gigabites.svg": "43f8",
	"./globe-darkmode.svg": "f057",
	"./globe.svg": "0474",
	"./go.svg": "d456",
	"./google.svg": "9bcd",
	"./googleAdsLogo.svg": "6df1",
	"./help-outline.svg": "7d0a",
	"./help-solid.svg": "5c38",
	"./history.svg": "76cd",
	"./hour.svg": "44d1",
	"./ia-credits.svg": "1c1b",
	"./indent.svg": "8e27",
	"./info-outline.svg": "3337",
	"./info-solid.svg": "afb9",
	"./key.svg": "d4aa",
	"./language.svg": "9cb2",
	"./like.svg": "121c",
	"./likeplus.svg": "2c70",
	"./link.svg": "4016",
	"./live.svg": "2792",
	"./loading-25.svg": "4301",
	"./logout.svg": "923b",
	"./manage.svg": "bb55",
	"./menu-action.svg": "28d8",
	"./menu.svg": "20f8",
	"./metaLogo.svg": "596d",
	"./mini-player.svg": "9298",
	"./minimize.svg": "cac6",
	"./minus-outline.svg": "ce49",
	"./minus.svg": "2684",
	"./news.svg": "36ed",
	"./notification.svg": "1c51",
	"./pause.svg": "14dc",
	"./phone.svg": "d82c",
	"./phone_dark.svg": "a5b0",
	"./pip.svg": "92ad",
	"./placeholder-ic.svg": "f1cf",
	"./plataformas-api.svg": "5e2c",
	"./plataformas-cademi.svg": "3e14",
	"./plataformas-eduzz.svg": "083f",
	"./plataformas-hotmart.svg": "cda5",
	"./plataformas-memberkit.svg": "4cb3",
	"./plataformas-the-members.svg": "9447",
	"./plataformas-ticto.svg": "0315",
	"./plataformas-xgrow.svg": "7bd4",
	"./play.svg": "e66b",
	"./player-search.svg": "3063",
	"./player-settings.svg": "975d",
	"./player.svg": "65b0",
	"./playlist.svg": "368f",
	"./promo-tag.svg": "f4ba",
	"./reais.svg": "183e",
	"./record.svg": "7c03",
	"./redo.svg": "7959",
	"./remove.svg": "983a",
	"./search.svg": "67a7",
	"./security-on.svg": "968b",
	"./security.svg": "598e",
	"./send.svg": "8360",
	"./sort-down.svg": "df2c",
	"./sort-up.svg": "4fd4",
	"./status-system.svg": "77ff",
	"./table.svg": "83f0",
	"./table_dark.svg": "9883",
	"./terabites.svg": "aa55",
	"./theme-day.svg": "5284",
	"./theme-night.svg": "d52c",
	"./tiktok.svg": "52e3",
	"./trash-autoplay.svg": "d750",
	"./undo.svg": "d692",
	"./upload.svg": "a237",
	"./video.svg": "578f",
	"./videos.svg": "0acc",
	"./voice-2.svg": "208b",
	"./voice.svg": "f00c",
	"./volume-max.svg": "c47a",
	"./volume-min.svg": "9c85",
	"./volume-mute.svg": "199a",
	"./zoom-in.svg": "0486",
	"./zoom-out.svg": "c396"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fdd";